import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField, Toggle } from "material-ui"
import strings from "../../localization/strings"
import { IPayrollPayCalendar, IPosition, IDate, IExpenseDocument, IUserDocument, ELoggedInUserType, IJobDocument, EExpenseScheduleTypeEnum, IUIUser, IPayrollPayGroupData, IExpenseBundle, IPriorPeriodData } from "../../models"
import * as utils from "../../helpers/utils"
import * as timeHelper from "../../helpers/timeHelper"
import AccountStore from "../../stores/AccountStore"
import IconDatePickerForPayPeriod from "../common/IconDatePickerForPayPeriod"
import moment from "moment"
import FileUpload from "../common/FileUpload"
import { grey400 } from "material-ui/styles/colors"
import AuditShow from "./AuditShow"
import FrequencySelector from "./FrequencySelector"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import ChooseHierarchyJobPhaseChipForPunch from "../../components/hierarchy/choose_hierarchy/ChooseHierarchyJobPhaseChipForPunch"
import DoubleField from "../common/DoubleField"
import PercentField from "../common/PercentField"
import _ from "lodash"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import Position_PayType_PayClass_Selector from "../position_paytype_payclass_selector/Position_PayType_PayClass_Selector"
import { checkPhaseFieldAvailable } from "../../helpers/punchHelper"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"
import AuditTable from "../audit/AuditTable"

interface IProps {
    loggedInUserType: ELoggedInUserType
    employee: IUserDocument
    payrollDataForPayGroup: IPayrollPayGroupData | IPayrollPayCalendar
    payPeriodReferenceDate: IDate
    editExpense: IExpenseDocument
    handleClose(): void
    handleAdd(expenseBundle: IExpenseBundle, scheduleType?: EExpenseScheduleTypeEnum): void
    handleUpdate(expenseBundle: IExpenseBundle, scheduleType?: EExpenseScheduleTypeEnum): void
    job?: IJobDocument
    showFrequencyControl?: boolean | null
    frequency?: number
    isOneTime?: boolean
    //it's LocalTime of UTC format
    payDate: IDate
    readonly?: boolean

    //add/edit on timecard
    timecard?: boolean

    //to keep same logic as like add punch when add from component timecard
    defaultAddHierarchyItemId?: string
    defaultAddJobId?: string
    defaultAddPhaseId?: string
    defaultAddPositionId?: string
    payrollHierarchyId: string
    payrollPayGroupId: string
}
interface IState {
    name: string
    errorName: string
    selectedPayTypeId: string
    errorSelectedPayTypeId: string
    internalErrorSelectedPayTypeId: string
    note: string
    isTime: boolean
    amount: string
    errorAmount: string
    errorRegAmount: string
    errorOTAmount: string
    errorOT2Amount: string
    payDate: IDate
    taxable: boolean
    employeeApproved: boolean
    supervisorApproved: boolean
    receiptFileId: string
    loadingReceiptFile: boolean
    frequency: number
    hierarchyLevelId: string
    errorHierarchyId: string
    jobId: string
    phaseId: string
    payRate: string
    billRate: string
    burden: number
    errorBurden: boolean
    regAmount: string
    OTAmount: string
    OT2Amount: string
    loadingPositions: boolean
    position: IPosition
    positionId: string
    errorPosition: string
    payClassId: string
    hierarchyLevelIntentionalChanged: boolean
    readonly: boolean
    priorPeriodAdjustment: boolean
}

export default class AddUserDetailExpenseDialog extends React.Component<IProps, IState> {
    private followPayClassName: boolean
    constructor(props: IProps) {
        super(props)
        this.followPayClassName = props.editExpense ? false : true

        let readOnly = props.readonly
        if (props.editExpense && props.editExpense.PayrollExport) {
            if (props.editExpense.PayrollExport.Exported) {
                readOnly = true
            }
        }

        this.state = {
            name: props.editExpense ? props.editExpense.Name : "",
            errorName: "",
            selectedPayTypeId: props.editExpense ? props.editExpense.PayTypeId : null,
            errorSelectedPayTypeId: null,
            internalErrorSelectedPayTypeId: null,
            note: props.editExpense ? props.editExpense.Note : "",
            readonly: readOnly,
            isTime: props.editExpense ?
                props.editExpense.IsTime :
                props.timecard ?
                    AccountStore.getTimecardAmountExpensesEnabled() ?
                        false :
                        true :
                    false,
            amount: props.editExpense ? props.editExpense.Amount.toString() : "",
            errorAmount: null,
            errorRegAmount: null,
            errorOTAmount: null,
            errorOT2Amount: null,
            payDate: props.editExpense ? timeHelper.keepConvertUTCToLocal(props.editExpense.PayDate) : (props.payDate ? timeHelper.keepConvertUTCToLocal(props.payDate) : null),
            taxable: props.editExpense ? props.editExpense.Taxable : true,
            employeeApproved: props.editExpense ? props.editExpense.EmployeeApproved : false,
            supervisorApproved: props.editExpense ? props.editExpense.SupervisorApproved : false,
            receiptFileId: props.editExpense ? props.editExpense.ReceiptFileId : null,
            loadingReceiptFile: false,
            frequency: props.editExpense ? props.frequency : this.props.isOneTime ? 0 : 1,
            hierarchyLevelId: props.editExpense ?
                props.editExpense.Classification ?
                    props.editExpense.Classification.HierarchyId :
                    props.employee.DefaultPunchHierarchyId :
                props.timecard ?
                    props.defaultAddHierarchyItemId :
                    props.employee.DefaultPunchHierarchyId,
            errorHierarchyId: null,
            jobId: props.editExpense ?
                props.editExpense.JobId :
                props.timecard ?
                    props.defaultAddJobId :
                    props.employee.DefaultJobId,
            phaseId: props.editExpense ?
                props.editExpense.Classification ?
                    props.editExpense.Classification.PhaseId :
                    null :
                props.timecard ?
                    props.defaultAddPhaseId :
                    props.employee.DefaultPhaseId,
            payRate: props.editExpense ? (props.editExpense.Classification ? (props.editExpense.Classification.PayRate ? props.editExpense.Classification.PayRate.toString() : null) : null) : null,
            billRate: props.editExpense ? (props.editExpense.Classification ? (props.editExpense.Classification.BillRate ? props.editExpense.Classification.BillRate.toString() : null) : null) : null,
            burden: props.editExpense ? (props.editExpense.Classification ? props.editExpense.Classification.Burden : null) : null,
            errorBurden: false,
            regAmount: props.editExpense ? props.editExpense.TimeDurations.RegularDurationInHours.toString() : "0",
            OTAmount: props.editExpense ? props.editExpense.TimeDurations.OTDurationInHours.toString() : "0",
            OT2Amount: props.editExpense ? props.editExpense.TimeDurations.OT2DurationInHours.toString() : "0",
            loadingPositions: true,
            positionId: props.editExpense ?
                props.editExpense.Classification ?
                    props.editExpense.Classification.PositionId :
                    null :
                props.timecard ?
                    props.defaultAddPositionId :
                    props.employee.DefaultPositionId,
            position: null,
            errorPosition: null,
            payClassId: props.editExpense && props.editExpense.Classification ? props.editExpense.Classification.PayClassId : null,
            hierarchyLevelIntentionalChanged: false,
            priorPeriodAdjustment: props.editExpense && props.editExpense.PriorPeriodData ? true : false,
        }

        autobind(this)
    }

    handleSave() {
        if (!this.checkValidate()) return

        const useTimeDuration = this.getUseTimeDuration()
        let amount = useTimeDuration ? 0 : Number(this.state.amount)
        let regAmount = useTimeDuration ? Number(this.state.regAmount) : 0
        const OTAmount = useTimeDuration ? Number(this.state.OTAmount) : 0
        const OT2Amount = useTimeDuration ? Number(this.state.OT2Amount) : 0
        const positionName = this.state.position ? this.state.position.Name : null

        const ratesValid = this.state.isTime && AccountStore.getRateTotalsEnabled()
        const payRate = ratesValid ? Number(this.state.payRate) : null
        const billRate = ratesValid ? Number(this.state.billRate) : null
        const burden = ratesValid ? this.state.burden : null
        let payTypeId = this.state.selectedPayTypeId

        let priorPeriodData = null
        let classification = {
            HierarchyId: this.state.hierarchyLevelId,
            HierarchyName: null,
            PhaseId: this.state.phaseId,
            PhaseName: null,
            PhaseCostCode: null,
            JobName: null,
            JobCostCode: null,
            PositionId: this.state.positionId,
            PositionName: positionName,
            PayClassId: this.state.payClassId,
            PayTypeName: null,
            PayCode: null,
            PayRate: payRate,
            BillRate: billRate,
            Burden: burden,
            TimeDurations: null,
            PayAmount: null,
            BillAmount: null,
            BurdenAmount: null
        }

        if (this.state.priorPeriodAdjustment) {
            const retroRegPayType = this.getRetroRegPayType()
            const retroOTPayType = this.getRetroOTPayType()
            const retroOT2PayType = this.getRetroOT2PayType()

            if (regAmount > 0 && OTAmount == 0 && OT2Amount == 0) {
                classification.PayTypeName = retroRegPayType.Name
                payTypeId = retroRegPayType.Id
                amount = regAmount
            } else if (regAmount == 0 && OTAmount > 0 && OT2Amount == 0) {
                classification.PayTypeName = retroRegPayType.Name
                payTypeId = retroOTPayType.Id
                amount = OTAmount
            } else if (regAmount == 0 && OTAmount == 0 && OT2Amount > 0) {
                classification.PayTypeName = retroRegPayType.Name
                payTypeId = retroOT2PayType.Id
                amount = OT2Amount
            }

            priorPeriodData = {
                IsPriorPeriodAdjustment: true,
                OriginalTimecardId: null,
                DiffTimecardId: null,
                ExportDateTime: null,
                ExportedBy: null,
                OriginalTimecardStartDate: null,
                OriginalExpenseId: null,
                DestinationTimecardId: null,
                DestinationTimecardStartDate: null,
            } as IPriorPeriodData

        }

        if (this.props.editExpense) {
            const payload = _.cloneDeep(this.props.editExpense)
            payload.Name = this.state.name.trim()
            payload.Note = this.state.note
            payload.PayTypeId = payTypeId
            payload.PayrollHierarchyId = this.props.editExpense.PayrollHierarchyId
            payload.PayrollPayGroupId = this.props.editExpense.PayrollPayGroupId
            payload.IsTime = this.state.isTime
            payload.Amount = amount
            payload.PayDate = moment(this.state.payDate).utc(true).format()
            payload.Taxable = this.state.taxable
            payload.EmployeeApproved = this.state.employeeApproved
            payload.SupervisorApproved = this.state.supervisorApproved
            payload.ReceiptFileId = this.state.receiptFileId
            payload.JobId = this.state.jobId
            payload.PriorPeriodData = priorPeriodData

            payload.TimeDurations = {
                RegularDurationInHours: regAmount,
                OTDurationInHours: OTAmount,
                OT2DurationInHours: OT2Amount,
                RegularDurationInMinutes: 0,
                OTDurationInMinutes: 0,
                OT2DurationInMinutes: 0,
            }

            payload.Classification = classification

            if (this.props.job) {
                payload.JobId = this.props.job.Id;
                this.props.handleUpdate(this.getExpenseBundle(payload), this.state.frequency)
            }
            else {
                this.props.handleUpdate(this.getExpenseBundle(payload))
            }
        }
        else {
            const payload = {
                Id: utils.guid(),
                AccountId: AccountStore.getCurrentAccount().Id,
                Name: this.state.name.trim(),
                Note: this.state.note,
                PayTypeId: payTypeId,
                PayrollHierarchyId: this.props.payrollHierarchyId,
                PayrollPayGroupId: this.props.payrollPayGroupId,
                IsTime: this.state.isTime,
                Amount: amount,
                PayDate: moment(this.state.payDate).utc(true).format(),
                Taxable: this.state.taxable,
                EmployeeApproved: this.state.employeeApproved,
                SupervisorApproved: this.state.supervisorApproved,
                ReceiptFileId: this.state.receiptFileId,
                JobId: this.state.jobId,
                PriorPeriodData: priorPeriodData,
                TimeDurations: {
                    RegularDurationInHours: regAmount,
                    OTDurationInHours: OTAmount,
                    OT2DurationInHours: OT2Amount,
                    RegularDurationInMinutes: 0,
                    OTDurationInMinutes: 0,
                    OT2DurationInMinutes: 0,
                },
                Classification: classification /*{
                    HierarchyId: this.state.hierarchyLevelId,
                    HierarchyName: null,
                    PhaseId: this.state.phaseId,
                    PhaseName: null,
                    PhaseCostCode: null,
                    JobName: null,
                    JobCostCode: null,
                    PositionId: this.state.positionId,
                    PositionName: positionName,
                    PayClassId: this.state.payClassId,
                    PayTypeName: null,
                    PayCode: null,
                    PayRate: payRate,
                    BillRate: billRate,
                    Burden: burden,
                    TimeDurations: null,
                    PayAmount: null,
                    BillAmount: null,
                    BurdenAmount: null
                }*/
            } as IExpenseDocument
            if (this.props.job) {
                payload.JobId = this.props.job.Id
                this.props.handleAdd(this.getExpenseBundle(payload), this.state.frequency)
            } else {
                payload.UserId = this.props.employee.Id
                this.props.handleAdd(this.getExpenseBundle(payload))
            }
        }
        this.props.handleClose()
    }

    getExpenseBundle(expense: IExpenseDocument): IExpenseBundle {
        return {
            Expense: expense,
            ExpensePosition: {
                Id: expense.Id,
                Position: this.state.position
            }
        }
    }

    checkValidate() {
        let isValidate = true
        if (!this.state.name.trim()) {
            this.setState({ errorName: strings.NameRequired })
            isValidate = false
        }
        else {
            this.setState({ errorName: "" })
        }

        if (this.state.errorHierarchyId) {
            isValidate = false
        }

        if (this.state.errorPosition) {
            isValidate = false
        }

        if (this.state.internalErrorSelectedPayTypeId) {
            isValidate = false
        }

        if (!this.state.selectedPayTypeId) {
            this.setState({ errorSelectedPayTypeId: strings.This_field_is_required })
            isValidate = false
        }
        else {
            if (!AccountStore.getTimecardTimeExpensesEnabled() && this.state.isTime && payGroupAndTypeHelper.getPayTypeById(this.state.selectedPayTypeId).UseTowardsOvertime) {
                this.setState({ errorSelectedPayTypeId: strings.Paytypes_that_contribute_to_overtime_cannot_be_used })
                isValidate = false
            }
            else {
                const allowedExpensePayTypeIds = permissionHelper.getAllowedExpensePayTypeIds()
                if (!allowedExpensePayTypeIds.includes(this.state.selectedPayTypeId)) {
                    this.setState({ errorSelectedPayTypeId: strings.this_paytype_not_allowed_by_role })
                    isValidate = false
                }
                else {
                    this.setState({ errorSelectedPayTypeId: "" })
                }
            }
        }

        let errorAmount, errorRegAmount, errorOTAmount, errorOT2Amount
        if (!this.getUseTimeDuration()) {
            let amountErrorString = this.getNumberErrorString(this.state.amount)
            if (amountErrorString.length > 0) {
                errorAmount = amountErrorString
            } else {
                if (this.state.isTime && Number(this.state.amount) === 0) {
                    errorAmount = strings.Not_allowed_0_hour
                }
                else {
                    errorAmount = ""
                }
            }
        } else {
            const regAmountErrorString = this.getNumberErrorString(this.state.regAmount)
            errorRegAmount = regAmountErrorString.length > 0 ? regAmountErrorString : ""

            const OTAmountErrorString = this.getNumberErrorString(this.state.OTAmount)
            errorOTAmount = OTAmountErrorString.length > 0 ? OTAmountErrorString : ""

            const OT2AmountErrorString = this.getNumberErrorString(this.state.OT2Amount)
            errorOT2Amount = OT2AmountErrorString.length > 0 ? OT2AmountErrorString : ""

            if (regAmountErrorString.length === 0 && OTAmountErrorString.length === 0 && OT2AmountErrorString.length === 0 &&
                Number(this.state.regAmount) === 0 && Number(this.state.OTAmount) === 0 && Number(this.state.OT2Amount) === 0
            ) {
                errorRegAmount = AccountStore.getHideOT2() ? strings.Reg_OT_are_0 : strings.Reg_OT_OT2_are_0
            }
            else {
                if (!regAmountErrorString.length)
                    errorRegAmount = ""
            }
        }

        if (this.state.priorPeriodAdjustment) {
            const regAmount = Number(this.state.regAmount)
            const otAmount = Number(this.state.OTAmount)
            const ot2Amount = Number(this.state.OT2Amount)

            if (
                (regAmount > 0 && otAmount > 0) ||
                (regAmount > 0 && ot2Amount > 0) ||
                (otAmount > 0 && ot2Amount > 0)
            ) {
                errorRegAmount = "Prior Period entry requires single reg, ot, or ot2 value"
            }

            if (regAmount > 0) {
                if (errorOTAmount === strings.This_field_is_required) {
                    errorOTAmount = ""
                }
                if (errorOT2Amount === strings.This_field_is_required) {
                    errorOT2Amount = ""
                }
            }

            if (otAmount > 0) {
                if (errorRegAmount === strings.This_field_is_required) {
                    errorRegAmount = ""
                }
                if (errorOT2Amount === strings.This_field_is_required) {
                    errorOT2Amount = ""
                }
            }

            if (ot2Amount > 0) {
                if (errorRegAmount === strings.This_field_is_required) {
                    errorRegAmount = ""
                }
                if (errorOTAmount === strings.This_field_is_required) {
                    errorOTAmount = ""
                }
            }
        }

        this.setState({ errorAmount })
        if (errorAmount && errorAmount.length > 0) {
            isValidate = false
        }

        this.setState({ errorRegAmount })
        if (errorRegAmount && errorRegAmount.length > 0) {
            isValidate = false
        }
        this.setState({ errorOTAmount })
        if (errorOTAmount && errorOTAmount.length > 0) {
            isValidate = false
        }
        this.setState({ errorOT2Amount })
        if (errorOT2Amount && errorOT2Amount.length > 0) {
            isValidate = false
        }
        return isValidate
    }

    getNumberErrorString(value) {
        value = value.trim()
        if (!value) {
            return strings.This_field_is_required
        } else if (Number.isNaN(Number(value))) {
            return strings.Invalid_format
        } else if (utils.getDecimalCount(Number(value)) > 2) {
            return strings.formatString(strings.Allowed_only_x_digit_decimal_point, 2) as string
        } else if (!this.state.isTime && Number(value) >= 1000000 || Number(value) <= -1000000) {
            return strings.formatString(strings.This_field_requires_a_number_between_min_and_max, -1000000, 1000000) as string
        } else {
            return ""
        }
    }

    getUseTimeDuration() {
        return this.state.isTime && this.state.selectedPayTypeId && payGroupAndTypeHelper.getPayTypeById(this.state.selectedPayTypeId).UseTowardsOvertime ?
            true :
            false
    }

    getPayClassName(position: IPosition, payClassId): string {
        if (position && position.AvailablePayClasses && payClassId) {
            const payClass = position.AvailablePayClasses.find(i => i.Id === payClassId)
            return payClass ? payClass.Name : ""
        }
        return ""
    }

    getRetroRegPayType() {
        const payType = AccountStore.CurrentAccount.PayTypes.find(item => item.Id == this.state.selectedPayTypeId)

        if (this.state.priorPeriodAdjustment) {
            if (payType.RetroPayTypeId) {
                return AccountStore.CurrentAccount.PayTypes.find(item => item.Id == payType.RetroPayTypeId)
            }
        }

        return payType
    }

    getRetroOTPayType() {
        const payType = AccountStore.CurrentAccount.PayTypes.find(item => item.Id == this.state.selectedPayTypeId)
        if (this.state.priorPeriodAdjustment) {
            if (payType.RetroOTPayTypeId) {
                return AccountStore.CurrentAccount.PayTypes.find(item => item.Id == payType.RetroOTPayTypeId)
            }
        }

        return payType
    }

    getRetroOT2PayType() {
        const payType = AccountStore.CurrentAccount.PayTypes.find(item => item.Id == this.state.selectedPayTypeId)
        if (this.state.priorPeriodAdjustment) {
            if (payType.RetroOT2PayTypeId) {
                return AccountStore.CurrentAccount.PayTypes.find(item => item.Id == payType.RetroOT2PayTypeId)
            }
        }

        return payType
    }

    render() {
        const ratesValid = this.state.isTime
        const payType = AccountStore.CurrentAccount.PayTypes.find(item => item.Id == this.state.selectedPayTypeId)
        let retroRegPayType = this.getRetroRegPayType()
        let retroOTPayType = this.getRetroOTPayType()
        let retroOT2PayType = this.getRetroOT2PayType()

        return (
            <Dialog
                open
                autoScrollBodyContent
                title={this.props.editExpense ? strings.Edit_Expense : strings.New_Expense}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={this.state.readonly
                    ?
                    [
                        <FlatButton data-intercom-target={"Expenses-Btn-CloseAddExpenseDialog"} label={strings.CANCEL} secondary onClick={this.props.handleClose} />
                    ]
                    :
                    [
                        <FlatButton data-intercom-target={"Expenses-Btn-CloseAddExpenseDialog"} label={strings.CANCEL} secondary onClick={this.props.handleClose} />,
                        <FlatButton data-intercom-target={"Expenses-Btn-SaveExpense"} disabled={this.state.loadingReceiptFile || this.state.loadingPositions} label={strings.SAVE} primary onClick={this.handleSave} />
                    ]
                }
            >
                <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                    <TextField
                        data-intercom-target={"Expenses-Entry-Name"}
                        fullWidth
                        floatingLabelText={strings.Name}
                        value={this.state.name}
                        onChange={(e, value) => {
                            this.followPayClassName = false
                            this.setState({ name: value }, () => this.checkValidate())
                        }}
                        errorText={this.state.errorName}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                        disabled={this.state.readonly}
                    />
                    <TextField
                        data-intercom-target={"Expenses-Entry-Description"}
                        fullWidth
                        floatingLabelText={strings.Description}
                        value={this.state.note}
                        onChange={(e, value) => this.setState({ note: value })}

                        disabled={this.state.readonly}
                    />
                    <div style={{ marginTop: 10 }}>
                        <ChooseHierarchyJobPhaseChipForPunch
                            byExpense
                            isPPAExpense={this.state.priorPeriodAdjustment}
                            hideIcon={false}
                            hierarchyChipLabel={strings.CHOOSE_HIERARCHY_ITEM}
                            jobChipLabel={checkJobFieldAvailable("singular") ? `Choose ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Choose_Job}
                            phaseChipLabel={checkPhaseFieldAvailable("singular") ? `Choose ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}` : strings.Choose_Phase}
                            employee={this.props.employee as IUIUser}
                            punchHierarchyItemId={this.state.hierarchyLevelId}
                            jobId={this.state.jobId}
                            phaseId={this.state.phaseId}
                            handleSelectHierarchyJobPhase={(hierarchyLevelId, errorHierarchyId, job, phase, intentionalChanged) =>
                                this.setState({
                                    hierarchyLevelId,
                                    errorHierarchyId,
                                    jobId: job ? job.Id : null,
                                    phaseId: phase ? phase.Id : null,
                                    hierarchyLevelIntentionalChanged: intentionalChanged ? true : this.state.hierarchyLevelIntentionalChanged
                                })
                            }
                            isEmployeePermissionPriority
                            searchJobByEmpPermission
                            readonly={this.state.readonly}
                            fixedHierarchy={this.props.job ? true : false}
                            fixedJob={this.props.job ? true : false}
                        />
                    </div>
                    <Position_PayType_PayClass_Selector
                        readonly={this.state.readonly}
                        date={this.state.payDate}
                        employee={this.props.employee as IUIUser}
                        hierarchyId={this.state.hierarchyLevelId}
                        shiftId={null}
                        jobId={this.state.jobId}
                        phaseId={this.state.phaseId}
                        selectedPositionId={this.state.positionId}
                        selectedPayTypeId={this.state.selectedPayTypeId}
                        selectedPayClassId={this.state.payClassId}
                        keepPropsPayClassId_PayTypeId={this.props.editExpense ? true : false}
                        handleLoadingPositions={loadingPositions => this.setState({ loadingPositions })}
                        handleSelectPosition={(position, errorPosition) => {
                            let name = this.state.name
                            if (this.followPayClassName && !position) {
                                name = ""
                            }
                            this.setState({ position, positionId: position ? position.Id : null, errorPosition, name }, () => this.checkValidate())
                        }}
                        handleSelectPayClass={payClassId => {
                            if (!this.state.position) return
                            const payClass = this.state.position.AvailablePayClasses ?
                                this.state.position.AvailablePayClasses.find(i => i.Id === payClassId) :
                                null

                            this.setState({
                                name: this.followPayClassName ?
                                    payClass ?
                                        payClass.Name :
                                        "" :
                                    this.state.name,
                                payClassId: payClass ? payClass.Id : null,
                                payRate: payClass && payClass.PayInfo ? payClass.PayInfo.PayRate.toString() : null,
                                billRate: payClass && payClass.PayInfo ? payClass.PayInfo.BillRate.toString() : null,
                                burden: payClass && payClass.PayInfo ? payClass.PayInfo.Burden : null
                            }, () => this.checkValidate())
                        }}
                        handleSelectPayType={(selectedPayTypeId, internalErrorSelectedPayTypeId) => this.setState({ selectedPayTypeId: internalErrorSelectedPayTypeId ? this.state.selectedPayTypeId : selectedPayTypeId, internalErrorSelectedPayTypeId }, () => this.checkValidate())}
                        referencePunchPositionDocumentId={this.props.editExpense ? this.props.editExpense.Id : null}
                        hierarchyLevelIntentionalChanged={this.state.hierarchyLevelIntentionalChanged}
                        errorSelectedPayTypeId={this.state.errorSelectedPayTypeId}
                        payTypeLabel={strings.Pay_Type}
                        hideIcons
                        hidePayInfo={!this.state.isTime}
                        readonlyPayClassSelector={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.EditRates)}
                        overridePositionInfo={AccountStore.getPayClassEnabled() && this.props.editExpense &&
                            this.props.editExpense.Classification &&
                            this.props.editExpense.Classification.PayClassId ?
                            {
                                Id: this.props.editExpense.Classification.PositionId,
                                PayTypeId: this.props.editExpense.PayTypeId,
                                DefaultPayClass: {
                                    Id: this.props.editExpense.Classification.PayClassId,
                                    PayInfo: {
                                        PayRate: this.props.editExpense.Classification.PayRate,
                                        BillRate: this.props.editExpense.Classification.BillRate,
                                        Burden: this.props.editExpense.Classification.Burden
                                    }
                                }
                            } as IPosition :
                            null
                        }
                    />

                    <div style={{ display: "flex", marginTop: 25 }}>
                        <div style={{ flex: 1 }}>
                            <Toggle
                                data-intercom-target={"Expenses-Toggle-TimeEntry"}
                                label={strings.Time_Entry}
                                style={{ width: 225 }}
                                toggled={this.state.isTime}
                                onToggle={(e, value) => this.setState({ isTime: value }, () => this.checkValidate())}
                                disabled={
                                    this.state.readonly ||
                                    (this.props.timecard && !AccountStore.getTimecardAmountExpensesEnabled()) ||
                                    (this.props.editExpense && AccountStore.getTimecardTimeExpensesEnabled() && !AccountStore.getTimecardAmountExpensesEnabled())
                                }
                            />
                        </div>
                        {AccountStore.getPriorPeriodAdjustmentsEnabled() &&
                            <div style={{ flex: 1 }}>
                                <Toggle
                                    label={"Prior Period Adjustment"}
                                    style={{ width: 225 }}
                                    toggled={this.state.priorPeriodAdjustment}
                                    onToggle={(e, value) => this.setState({ priorPeriodAdjustment: value }, () => this.checkValidate())}
                                    disabled={this.state.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.PriorPeriodAdjustments)}
                                />
                            </div>
                        }
                    </div>

                    <div style={{ display: "flex" }}>
                        {this.getUseTimeDuration() ?
                            [
                                <div key="reg" style={{ flex: 1, marginRight: 5 }}>
                                    <TextField
                                        data-intercom-target={"Expenses-Entry-RegHours"}
                                        floatingLabelText={this.state.isTime ? strings.Reg_Hours : strings.Amount}
                                        value={this.state.regAmount}
                                        onChange={(e, value) => this.setState({ regAmount: value }, () => this.checkValidate())}
                                        errorText={this.state.errorRegAmount}
                                        errorStyle={{ position: "absolute", top: 70 }}
                                        disabled={this.state.readonly}
                                        style={{ width: 175 }}
                                    />
                                    {this.state.priorPeriodAdjustment && retroRegPayType.Id != payType.Id &&
                                        <div style={{ fontSize: 10, marginTop: 20 }}>
                                            <b>Retro PayType:</b> {retroRegPayType.Name}
                                        </div>
                                    }
                                </div>,
                                <div key="ot" style={{ flex: 1, marginRight: 5 }}>
                                    <TextField
                                        data-intercom-target={"Expenses-Entry-OTHours"}
                                        floatingLabelText={this.state.isTime ? strings.OT_Hours : strings.Amount}
                                        value={this.state.OTAmount}
                                        onChange={(e, value) => this.setState({ OTAmount: value }, () => this.checkValidate())}
                                        errorText={this.state.errorOTAmount}
                                        errorStyle={{ position: "absolute", top: 70 }}
                                        disabled={this.state.readonly}
                                        style={{ width: 175 }}
                                    />
                                    {this.state.priorPeriodAdjustment && retroOTPayType.Id != payType.Id &&
                                        <div style={{ fontSize: 10, marginTop: 20 }}>
                                            <b>Retro PayType:</b> {retroOTPayType.Name}
                                        </div>
                                    }
                                </div>,
                                !AccountStore.getHideOT2() &&
                                <div key="ot2" style={{ flex: 1, marginRight: 5 }}>
                                    <TextField
                                        data-intercom-target={"Expenses-Entry-OT2Hours"}
                                        floatingLabelText={this.state.isTime ? strings.OT2_Hours : strings.Amount}
                                        value={this.state.OT2Amount}
                                        onChange={(e, value) => this.setState({ OT2Amount: value }, () => this.checkValidate())}
                                        errorText={this.state.errorOT2Amount}
                                        errorStyle={{ position: "absolute", top: 70 }}
                                        disabled={this.state.readonly}
                                        style={{ width: 175 }}
                                    />
                                    {this.state.priorPeriodAdjustment && retroOT2PayType.Id != payType.Id &&
                                        <div style={{ fontSize: 10, marginTop: 20 }}>
                                            <b>Retro PayType:</b> {retroOT2PayType.Name}
                                        </div>
                                    }
                                </div>
                            ] :
                            <div style={{ flex: 1 }}>
                                <TextField
                                    data-intercom-target={"Expenses-Entry-AmountOrHours"}
                                    floatingLabelText={this.state.isTime ? strings.Enter_Hours : strings.Amount}
                                    value={this.state.amount}
                                    onChange={(e, value) => this.setState({ amount: value }, () => this.checkValidate())}
                                    errorText={this.state.errorAmount}
                                    errorStyle={{ position: "absolute", top: 70 }}
                                    disabled={this.state.readonly}
                                />
                            </div>
                        }
                    </div>
                    {
                        ratesValid &&
                        (AccountStore.getPayClassEnabled() ?
                            (!this.state.position || !this.state.position.DefaultPayClass) :
                            true
                        ) &&
                        <div style={{ display: "flex" }}>
                            <div style={{ flex: 1, display: "flex" }}>
                                <span style={{ marginTop: 40, marginRight: 5 }}>$</span>
                                <DoubleField
                                    name="PayRate"
                                    style={{ width: 100 }}
                                    label={strings.Pay_Rate}
                                    value={this.state.payRate}
                                    handleChange={payRate => this.setState({ payRate })}
                                    readonly={this.state.readonly}
                                />
                            </div>
                            <div style={{ flex: 1, display: "flex" }}>
                                <span style={{ marginTop: 40, marginRight: 5 }}>$</span>
                                <DoubleField
                                    name="BillRate"
                                    style={{ width: 100 }}
                                    label={strings.Bill_Rate}
                                    value={this.state.billRate}
                                    handleChange={billRate => this.setState({ billRate })}
                                    readonly={this.state.readonly}
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <PercentField
                                    label={strings.Burden}
                                    style={{ width: 100 }}
                                    percent={this.state.burden}
                                    handleChange={(burden, errorBurden) => this.setState({ burden, errorBurden })}
                                    readonly={this.state.readonly}
                                />
                            </div>
                        </div>
                    }
                    <IconDatePickerForPayPeriod
                        label={strings.Expense_Date}
                        payrollDataForPayGroup={this.props.payrollDataForPayGroup}
                        payPeriodReferenceDate={this.props.payPeriodReferenceDate}
                        selectedDate={this.state.payDate}
                        handleSelectDate={payDate => this.setState({ payDate })}
                        readonly={this.state.readonly}
                    />
                    {this.props.showFrequencyControl &&
                        <FrequencySelector handleSelection={frequency => this.setState({ frequency })} frequency={this.state.frequency} />
                    }
                    <div style={{ display: "flex", marginTop: 25 }}>
                        <div style={{ flex: 1 }}>
                            <Toggle
                                data-intercom-target={"Expenses-Toggle-Taxable"}
                                label={strings.Taxable}
                                disabled={this.props.loggedInUserType === ELoggedInUserType.Employee || this.state.readonly}
                                style={{ width: 225 }}
                                toggled={this.state.taxable}
                                onToggle={(e, value) => this.setState({ taxable: value })}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            {this.props.loggedInUserType === ELoggedInUserType.Employee ?
                                <Toggle
                                    data-intercom-target={"Expenses-Toggle-EmployeeApproved"}
                                    label={strings.Employee_Approved}
                                    style={{ width: 225 }}
                                    toggled={this.state.employeeApproved}
                                    onToggle={(e, value) => this.setState({ employeeApproved: value })}
                                    disabled={this.state.readonly}
                                /> :
                                <Toggle
                                    data-intercom-target={"Expenses-Toggle-SupervisorApproved"}
                                    label={strings.Supervisor_Approved}
                                    style={{ width: 225 }}
                                    toggled={this.state.supervisorApproved}
                                    onToggle={(e, value) => this.setState({ supervisorApproved: value })}
                                    disabled={this.state.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.ApproveEmployeeExpense)}
                                />
                            }
                        </div>
                    </div>
                    <div style={{ marginTop: 15, display: "flex" }}>
                        {!this.state.readonly &&
                            <div>
                                <div style={{ fontSize: 14, color: grey400, marginBottom: 4 }}>{strings.Receipt}</div>
                                <FileUpload
                                    fileDocumentId={this.state.receiptFileId}
                                    handleChangeFileId={receiptFileId => this.setState({ receiptFileId })}
                                    handleChangeloadStatus={loading => this.setState({ loadingReceiptFile: loading })}
                                />
                            </div>
                        }
                        {this.props.editExpense &&
                            <div style={{ marginLeft: 25, marginTop: 20, flex: "auto" }}>
                                <AuditShow label={strings.Last_Modified} audit={this.props.editExpense.ObjectAudit} />
                                {this.props.editExpense.SupervisorApproved && this.props.editExpense.SupervisorApprovalAudit &&
                                    <AuditShow label={strings.Supervisor_Approved} audit={this.props.editExpense.SupervisorApprovalAudit} />
                                }
                                {this.props.editExpense.EmployeeApproved && this.props.editExpense.EmployeeApprovalAudit &&
                                    <AuditShow label={strings.Employee_Approved} audit={this.props.editExpense.EmployeeApprovalAudit} />
                                }
                            </div>
                        }
                    </div>
                    {this.props.editExpense &&
                        <div style={{ marginTop: 10, padding: 10, borderTop: "solid 1px #cccccc", position: "relative" }}>
                            <AuditTable
                                audits={this.props.editExpense.Audits}
                                hierarchyId={this.props.editExpense.Classification.HierarchyId}
                                jobId={this.props.editExpense.JobId}
                            />
                        </div>
                    }
                </div>
            </Dialog>
        )
    }
}